import api from '@/js/services/api';

export default {

    delete(id) {
        return api().delete(`user/emergency-contact/` + id + '/delete');
    },
}
